// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UlvF","colMin":"styles_colMin__2dRp9"};